<template>
  <v-container fluid pt-0 pt-md-3>
    <v-card class="mx-auto">
      <v-row no-gutters>
        <v-col sm="3" lg="2" cols="12" class="border-right user-column-left">
          <v-row no-gutters>
            <v-col cols="12">
              <v-btn
                @click.stop="onHomeClicked"
                absolute
                top
                text
                class="user-back-button"
              >
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-card flat>
                <v-card-title class="justify-center">
                  <v-avatar color="secondary" size="128">
                    <v-icon color="black" class="account-avatar-icon">
                      mdi-account
                    </v-icon>
                  </v-avatar>
                </v-card-title>
                <v-card-subtitle>
                  <div class="text-center overline mb-0">
                    {{ loggedInUser.roleName }}
                  </div>
                  <div class="text-center text-h6 primary--text">
                    {{ loggedInUser.email }}
                  </div>
                </v-card-subtitle>
              </v-card>
              <v-card-text class="pa-0">
                <v-divider></v-divider>
                <v-list class="px-0 pt-0 pb-4 user-view-list-nav">
                  <v-list-item
                    router
                    dense
                    active-class="secondary user-view-active-item"
                    :to="{ name: 'userAccountProfile' }"
                  >
                    <v-list-item-icon class="mr-5">
                      <v-icon color="accent">mdi-card-account-details</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="text-capitalize">
                        {{ $t("users.settings.menuItems.profile") }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    router
                    dense
                    active-class="secondary user-view-active-item"
                    :to="{ name: 'userAccountSettings' }"
                  >
                    <v-list-item-icon class="mr-5">
                      <v-icon color="accent">mdi-cog</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="text-capitalize">
                        {{ $t("users.settings.menuItems.settings") }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-col>
          </v-row>
        </v-col>

        <v-col sm="9" lg="10" cols="12">
          <router-view></router-view>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
export default {
  computed: {
    loggedInUser() {
      return this.$store.getters.loggedInUser
    }
  },
  methods: {
    onHomeClicked() {
      this.$router.push("/home")
    }
  }
}
</script>

<style type="scss">
.account-avatar-icon::before {
  font-size: 5rem;
}
</style>
